import EmojiPicker, { Theme } from "emoji-picker-react";
import { useColorMode } from "../../ui/color-mode";
import { cn } from "../../../lib/utils";

export default function ChatEmojiPicker({ onEmojiSelect, className }) {
  const { colorMode } = useColorMode();

  return (
    <div
      className={cn(
        "absolute bottom-full left-0 mb-2 z-50 shadow-lg rounded-lg overflow-hidden border border-gray-200 dark:border-slate-700",
        className
      )}
    >
      <EmojiPicker
        onEmojiClick={(data) => onEmojiSelect(data.emoji)}
        theme={colorMode === "dark" ? Theme.DARK : Theme.LIGHT}
        width={320}
        height={360}
        lazyLoadEmojis
        previewConfig={{ showPreview: false }}
      />
    </div>
  );
}
